<template>
  <div class="select-subs">
    <label class="d-label">{{ $t('vue2.substitution.find_sub_for') }} </label>
    <div class="select-subs__header">
      <FilterUsers></FilterUsers>
    </div>
    <div class="select-subs__header">
      <input type="search" class="search-user" :placeholder="$t('vue2.common.search_name_or_initials')" @input="debounceSearch">
    </div>
    <ul>
      <li v-if="usersSorted.length === 0" class="italic">{{ $t('vue2.dselect.no_matching_results') }}</li>
      <li
        v-for="(user, index) in usersSorted"
        :key="user.id"
        class="select-subs__sub shadow"
      >
        <div class="select-subs__sub__header">
          <p class="select-subs__sub__name">{{ user.name }}</p>
        </div>
        <button @click="addSub(user)" class="bttn">
          {{ $t('vue2.common.select') }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import FilterUsers from '../../Tagging/FilterUsers'

export default {
  components: {FilterUsers},
  props: {
    selectedEvents: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      users: [],
      isLoading: true,
      searchQuery: '',
      debounceTimer: null
    }
  },
  computed: {
    ...mapGetters([
      'usersFilteredWithTags',
      'allUsersInCalIdHash'
    ]),
    activeAbsentUser () {
      return this.$store.state.subs.activeAbsentUser
    },
    activeUserEvents () {
      return this.$store.state.subs.activeAbsentUserEvents
    },
    filteredUsers () {
      return this.usersFilteredWithTags.filter(
        user => user.user_calendar_id !== this.activeAbsentUser.user_calendar_id
      )
    },
    usersSorted () {
      // Filter the users based on the debounced search query
      if (!this.searchQuery) {
        return this.filteredUsers
      }
      const lowercasedQuery = this.searchQuery.toLowerCase()

      return this.filteredUsers.filter(user => {
        // Check if either name or initials match the search query
        return (
          user.name.toLowerCase().includes(lowercasedQuery) ||
          (user.initials && user.initials.toLowerCase().includes(lowercasedQuery))
        )
      })
    }
  },
  methods: {
    addSub (user) {
      if (this.selectedEvents.length < 1) {
        window.alert(this.$t('vue2.substitution.select_lessons_to_substitute'))
        return
      }
      this.$emit('addSub', user)
    },
    debounceSearch (event) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.searchQuery = event.target.value
      }, 400)
    }
  },
  beforeDestroy () {
    // Clean up any active timeouts
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }
}
</script>

<style scoped>
@import "../../../../src/assets/css/variables.css";

.select-subs {
  padding: 1rem;
}

.select-subs__header {
  padding: 1rem 0;
}

.select-subs__sub {
  background: #ffffff;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-color);
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

.select-subs__sub__header {
  display: flex;
  align-items: center;
}

.select-subs__sub__header img {
  width: 45px;
  height: 45px;
  border-radius: 4px;
  margin-right: 1rem;
}

.select-subs__sub__name {
  font-weight: bold;
}

input[type="search"].search-user {
  border: 1px solid #acb6be;
  background: #fff;
}

input[type="search"].search-user:focus {
  border: 1px solid #468ad7;
}

.select-subs__sub__status {
  font-style: italic;
}

.fadeInUp-initial {
  animation-duration: 0.5s;
  animation-fill-mode: both;
}

.list-complete-item-animation {
  transition: all 0.5s;
  width: 100%;
}

.list-complete-enter, .list-complete-leave-to
  /* .list-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}

.linear-background {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1000px 104px;
  height: 16px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// SubsUserPanelSubs2.vue?1ee807e3